import { memo, useState } from 'react';
import { Edit, ExpandMore } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  Grid,
  IconButton,
  Typography,
  useEventCallback,
} from '@mui/material';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { useFormikContext } from 'formik';
import PmiTextField from 'shell/components/shared/text-field';
import { HistoryCohabitationVM } from 'cohabitation/view-models/history-cohabitation';
import ModalInsertAddress from './modify-historian-modal';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { __PERSON_API_URL__ } from 'shell/constants/environment';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { toast } from 'react-toastify';

interface AccordionHistorianAddressProps {
  isEdit?: boolean;
}

const AccordionHistorianAddressComponent = ({
  isEdit,
}: AccordionHistorianAddressProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(false);

  const [openModal, setOpenModal] = useState<boolean>(false);

  const form = useFormikContext<HistoryCohabitationVM>();

  const onEditPress = useEventCallback(() => {
    setOpenModal(true);
  });

  const updateData = useHttpClient(`${__PERSON_API_URL__}/persona/convivenza/indirizzo`, {
    options: { method: 'PUT' },
  });

  return (
    <Accordion expanded={open} onChange={() => setOpen(!open)}>
      <AccordionSummary
        aria-controls="panel-historian-faddress-content"
        id="panel-historian-address-content"
        expandIcon={<ExpandMore />}
      >
        <Typography>Gestione Storico indirizzi Convivenza</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          <Grid item xs={12} container spacing={2}>
            <Grid item xs={12} md={10}>
              <PmiTextField
                id="address"
                label="Indirizzo"
                aria-label="Indirizzo"
                fullWidth
                disabled
                helperText={form.errors.address}
                error={form.touched.address && Boolean(form.errors.address)}
                value={form.values.address || ''}
                onChange={(event) => form.setFieldValue('address', event.target.value)}
              />
            </Grid>
            {isEdit ? (
              <Grid item xs={12} md={1}>
                <IconButton
                  onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    onEditPress();
                  }}
                  aria-label="Modifica elemento"
                  aria-haspopup="true"
                  style={{
                    padding: '4px',
                  }}
                >
                  <Edit />
                </IconButton>
              </Grid>
            ) : undefined}
          </Grid>
          <Grid item xs={12} md={4}>
            <PmiTextField
              id="numberCivic"
              label="Nr civico"
              aria-label="Nr civico"
              fullWidth
              disabled
              value={form.values.numberCivic || ''}
              onChange={(event) => form.setFieldValue('numberCivic', event.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <PmiTextField
              id="letterCivic"
              label="Lettera"
              aria-label="Lettera"
              fullWidth
              disabled
              value={form.values.letterCivic || ''}
              onChange={(event) => form.setFieldValue('letterCivic', event.target.value)}
            />
          </Grid>
        </Grid>
        <ModalInsertAddress
          modalData={{
            address: form.values.address || '',
            numberCivic: form.values.numberCivic || '',
            letterCivic: form.values.letterCivic || '',
          }}
          open={openModal}
          onClose={() => setOpenModal(false)}
          onSubmit={(values) => {
            (
              updateData({
                data: {
                  descrizioneToponimo: values.address,
                  numeroCivico: values.numberCivic,
                  esponenteCivico: values.letterCivic,
                  key: {
                    codice: form.values.cohabitationData?.idSipo,
                  },
                },
              }) as ResponsePromise<void>
            ).then(() => {
              // chiamata be
              form.setValues({ ...form.values, ...values });
              setOpenModal(false);
              toast.success('Operazione eseguita con successo');
            });
          }}
        />
      </AccordionDetails>
    </Accordion>
  );
};

AccordionHistorianAddressComponent.displayName = 'Change control data accordion component';

const AccordionHistorianAddress = memo(AccordionHistorianAddressComponent);

export default AccordionHistorianAddress;
